import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

function useUnreadNotifications() {
  const { currentUser } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!currentUser) {
      setUnreadCount(0);
      return;
    }

    let unsubscribe;
    let active = true;

    (async () => {
      try {
        const { collection, query, where, onSnapshot } = await import('firebase/firestore');
        const { db } = await import('../firebase');
        const unreadQuery = query(
          collection(db, 'notifications'),
          where('recipientId', '==', currentUser.uid),
          where('isRead', '==', false)
        );

        unsubscribe = onSnapshot(
          unreadQuery,
          (snapshot) => {
            if (active) {
              setUnreadCount(snapshot.size);
            }
          },
          (error) => {
            if (error?.code !== 'permission-denied') {
              console.error('未読通知数の取得に失敗しました', error);
            }
            if (active) {
              setUnreadCount(0);
            }
          }
        );
      } catch (error) {
        if (active) {
          setUnreadCount(0);
        }
      }
    })();

    return () => {
      active = false;
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [currentUser]);

  return unreadCount;
}

export default useUnreadNotifications;
